<template>
  <v-container  class="mx-2">
    <v-row>
      <v-col cols="12" lg="11">
        <v-breadcrumbs
          class="pl-0 pt-0"
          :items="items"
        ></v-breadcrumbs>
        <h1 class="mb-2">{{ $route.meta.title }}</h1>
        <v-form
          ref="formAddAgent"
          v-model="valid"
          lazy-validation
        >
          <v-row>
            <v-col
              cols="8"
              sm="5"
              class="pb-0"
            >
              <v-text-field
                label="Юридический адрес"
                v-model='formAgent.legalAddress'
                :rules='rules.universal'
                solo
                outlined
                dense
                flat
                required
              ></v-text-field>
            </v-col>

            <v-col
              cols="8"
              sm="5"
              class="pb-0"
            >
              <v-text-field
                label="Фактический адрес"
                v-model='formAgent.actualAddress'
                :rules='rules.universal'
                solo
                outlined
                dense
                flat
                required
              ></v-text-field>
            </v-col>

            <v-col
              cols="8"
              sm="5"
              class="py-0"
            >
              <v-text-field
                label="Имя"
                v-model='formAgent.name'
                :rules='rules.universal'
                solo
                outlined
                dense
                flat
                required
              ></v-text-field>
            </v-col>
            <v-col
              cols="8"
              sm="5"
              class="py-0"
            >
              <v-text-field
                label="Контактное лицо"
                v-model='formAgent.contact'
                :rules='rules.universal'
                solo
                outlined
                dense
                flat
                required
              ></v-text-field>
            </v-col>

            <v-col
              cols="8"
              sm="5"
              class="py-0"
            >
              <v-text-field
                label="ИНН"
                v-model='formAgent.inn'
                :rules='rules.inn'
                type="number"
                solo
                outlined
                dense
                flat
                required
              ></v-text-field>
            </v-col>

            <v-col
              cols="8"
              sm="5"
              class="py-0"
            >
              <v-text-field
                label="Телефон"
                v-model='formAgent.telephone'
                :rules='rules.telephone'
                solo
                outlined
                dense
                flat
                required
              ></v-text-field>
            </v-col>

            <v-col
              cols="8"
              sm="5"
              class="py-0"
            >
              <v-text-field
                label="Диспетчерская"
                v-model='formAgent.dispatcherPhone'
                :rules='rules.universal'
                solo
                outlined
                dense
                flat
                required
              ></v-text-field>
            </v-col>

            <v-col
              cols="8"
              sm="5"
              class="py-0"
            >
              <v-text-field
                label="Руководитель"
                v-model='formAgent.supervisor'
                :rules='rules.universal'
                solo
                outlined
                dense
                flat
                required
              ></v-text-field>
            </v-col>

            <v-col
              cols="8"
              sm="5"
              class="py-0"
            >
              <v-text-field
                label="Email"
                v-model='formAgent.email'
                :rules='rules.email'
                solo
                outlined
                dense
                flat
                required
              ></v-text-field>
            </v-col>

            <v-col
              cols="8"
              sm="5"
              class="py-0"
            >
              <v-text-field
                label="Пароль"
                v-model='formAgent.password'
                :rules='rules.password'
                autocomplete="new-password"
                solo
                outlined
                dense
                flat
                required
                type='password'
              ></v-text-field>
            </v-col>

            <v-col
              cols="8"
              sm="5"
              class="py-0"
            >
              <v-text-field
                label="Подтверждение пароля"
                v-model='formAgent.passwordConfirmation'
                :rules='rules.passwordConfirmation'
                autocomplete="new-password"
                solo
                outlined
                dense
                flat
                required
                type='password'
              ></v-text-field>
            </v-col>
          </v-row>

          <v-card-actions class="pl-0">
            <div class="my-2">
              <v-btn
                large
                color="success"
                class="text-none"
                dark
                @click="validate()"
              >
                Сохранить
              </v-btn>
              <v-btn
                @click.prevent="returnAgents()"
                large
                class="ma-2 text-none"
                outlined
                dense
                hide-details
                color="error"

              >
                Отменить
              </v-btn>
            </div>
          </v-card-actions>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'NewAgent',
  data () {
    return {
      valid: true,
      formAgent: {
        name: '',
        email: '',
        inn: '',
        legalAddress: '',
        actualAddress: '',
        contact: '',
        telephone: '',
        supervisor: '',
        password: '',
        passwordConfirmation: '',
        dispatcherPhone: '',
      },
      rules: {
        universal: [
          v => !!v || 'Поле обязательно для заполнения',
        ],
        email: [
          v => /.+@.+\..+/.test(v) || 'E-mail должен быть корректным',
        ],
        inn: [
          v => (v.length > 5 && v.length < 11) || 'ИНН должен быть от 6  до 10 цифр',
        ],
        telephone: [
          v => /^\d{11}$/.test(v) || 'Укажите корректный номер телефона',
        ],
        password: [
          v => v.length > 5 || 'Пароль должен быть не менее 6 символов',
        ],
        passwordConfirmation: [
          v => v.length > 5 || 'Пароль должен быть не менее 6 символов',
          v => v === this.formAgent.password || 'Пароли не совпадают',
        ],
      },
      items: [
        {
          text: 'Агенты',
          disabled: false,
          href: '/agents',
        },
        {
          text: 'Новый агент',
          disabled: true,
          href: 'breadcrumbs_link_1',
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      agent: 'Agents/agent',
    }),
  },
  methods: {
    ...mapActions({
      newAgent: 'Agents/newAgent',
      loadAgent: 'Agents/loadAgent',
      updateAgent: 'Agents/updateAgent',
    }),

    returnAgents () {
      this.$router.push({ name: 'Agents' });
    },

    validate () {
      if (this.$refs.formAddAgent.validate()) {
        const tempAgent = {
          password: this.formAgent.password,
          password_confirmation: this.formAgent.passwordConfirmation,
          name: this.formAgent.name,
          email: this.formAgent.email,
          inn: this.formAgent.inn,
          legal_address: this.formAgent.legalAddress,
          actual_address: this.formAgent.actualAddress,
          contact: this.formAgent.contact,
          telephone: this.formAgent.telephone,
          supervisor: this.formAgent.supervisor,
          dispatcher_phone: this.formAgent.dispatcherPhone,
        };

        this.newAgent(tempAgent)
          .then(() => {
            this.$router.push({ name: 'Agents' });
            this.$flash_success('Агент успешно создан');
          })
          .catch((err) => {
            if (err.message.includes('422')) {
              const response = err.response.data;
              for (const input in response) {
                response[input].forEach(error => this.$flash_warning(input + ': ' + error));
              }
            } else {
              this.$flash_warning('Ошибка при создании агента');
            }
          });
      }
    },
  },
};
</script>
